"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _bookCargo = _interopRequireDefault(require("./components/bookCargo"));
var _bookingMainTemplate = _interopRequireDefault(require("./components/bookingMainTemplate.vue"));
var _utils = require("@/utils");
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
var _dropTitle = _interopRequireDefault(require("./components/dropTitle.vue"));
var _boxInfo = _interopRequireDefault(require("./components/boxInfo.vue"));
var _bookInfo = _interopRequireDefault(require("./components/bookInfo.vue"));
var _consignerInfo = _interopRequireDefault(require("./components/consignerInfo"));
var _consignerReceiveInfo = _interopRequireDefault(require("./components/consignerReceiveInfo"));
var _consignerInfoOne = _interopRequireDefault(require("./components/consignerInfoOne"));
var _consignerInfoTwo = _interopRequireDefault(require("./components/consignerInfoTwo"));
var _MessageInputText = _interopRequireDefault(require("./components/MessageInputText.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "myBookingTemplateDetail",
  components: {
    sailSchedule: _SailSchedule.default,
    bookingMainTemplate: _bookingMainTemplate.default,
    dropTitle: _dropTitle.default,
    boxInfo: _boxInfo.default,
    bookInfo: _bookInfo.default,
    bookCargo: _bookCargo.default,
    consignerInfo: _consignerInfo.default,
    consignerReceiveInfo: _consignerReceiveInfo.default,
    consignerInfoOne: _consignerInfoOne.default,
    consignerInfoTwo: _consignerInfoTwo.default,
    MessageInputText: _MessageInputText.default
  },
  data: function data() {
    return {
      currentDialogIndex: '',
      dialogContent: '',
      clickButton: false,
      showDisplay: false,
      copyId: '',
      isDisable: false,
      dialogVisible: false,
      disabledType: false,
      copyVisible: false,
      sailScheduleDialogVisible: false,
      vessNameVoy: '',
      bookingId: '',
      templateType: '',
      form: {
        priceRemark: '',
        remark: '',
        // 是否订舱推广
        singleContainerFlag: 0,
        webBkSocComs: [],
        webBkImoComs: [],
        webBkYardComs: [{
          pickupYard: '',
          returnYard: '',
          pickupDate: ''
        }],
        webFeeItemComs: [],
        webBkDocumentComs: [],
        webBkRoutingComs: [],
        webBkReeferComs: [],
        webBkAkComs: [],
        webBkHgComs: [],
        webBkContainerComs: [],
        webBkPreContainerComs: [{
          containerType: '',
          quantity: null,
          cargoTypeCode: '',
          pickupDate: '',
          returnDate: '',
          pickUpDepot: '',
          returnDepot: ''
        }],
        //下货箱信息
        vesselCode: '',
        vesselName: '',
        vesselNameCn: '',
        saillingDate: '',
        eta: '',
        bookingFwdPerson: '',
        bookingFwdTel: '',
        bookingFwdEmail: '',
        actualShipper: '',
        bkNo: '',
        blNo: '',
        bookingType: '',
        transportationTerms: '',
        paidPalce: '',
        paidType: '',
        etd: '',
        // documentType:'',
        deliveryDocumentMethod: 1,
        wbillNo: '',
        agreementNo: '',
        freeTimeNo: 'NIL',
        expCustomsCargoType: '',
        sales: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        porName: '',
        polName: '',
        podName: '',
        delName: '',
        vipFlag: 0,
        masterBlFlag: 0,
        cargoDesc: '',
        cargoGrossWeight: null,
        tsFlag: 0,
        dgCheckFlag: 0,
        rfCheckFlag: 0,
        akCheckFlag: 0,
        socCheckFlag: 0,
        hgCheckFlag: 0,
        cargoPackageType: 'PKGS',
        //包装类型
        cargoPackageDesc: 'PACKAGE(S)',
        //包装描述
        cargoQuantity: 0,
        //货物数量
        cargoSize: 0,
        //货物重量
        commodityName: null,
        cargoShippingMark: 'N/M',
        //唛头,
        docCommodity: null,
        hsCode: null,
        hsCodeCn: null,
        hsCodeJp: null,
        webBkCargoComs: [{
          commodityCode: null
        }],
        webBkCustomerComs: [{
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 0,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 1,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 2,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 3,
          webBkCusCatalogComs: []
        }]
      },
      packageDescList: [],
      packageTypeList: [],
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: 1,
        name: 'Reshipment'
      }],
      contactTypeCodeList: [],
      rateBaseList: [{
        value: '0',
        labelZh: '摄氏度',
        labelEh: '摄氏度'
      }, {
        value: '1',
        labelZh: '华氏度',
        labelEh: '华氏度'
      }],
      transportationTermsList: [{
        value: '1',
        labelZh: 'SIMIS主系统基础数据-运输条款',
        labelEh: 'SIMIS main system basic data - Shipping terms'
      }],
      bookingTypeList: [],
      paidTypeList: [{
        value: '0',
        labelEh: 'PP'
      }, {
        value: '1',
        labelEh: 'CC'
      }],
      documentTypeList: [{
        value: '0',
        labelZh: '提单',
        labelEh: 'BILL OF LADING'
      }, {
        value: '1',
        labelZh: '海运提单',
        labelEh: 'SEA WAYBILL'
      }],
      cargoList: [{
        value: '0',
        labelEh: 'Export'
      }, {
        value: '1',
        labelEh: 'Reshipment'
      }],
      containerTypeList: [{
        value: '0',
        labelEh: '20GP'
      }, {
        value: '1',
        labelEh: '40GP'
      }],
      cargoTypeCodeList: [{
        value: '0',
        labelZh: '普通',
        labelEh: 'DRY'
      }, {
        value: '1',
        labelZh: '冻货',
        labelEh: 'REEFER'
      }, {
        value: '2',
        labelZh: '半危',
        labelEh: 'SEMI-HAZ'
      }, {
        value: '3',
        labelZh: '全危',
        labelEh: 'HAZARDOUS'
      }, {
        value: '4',
        labelZh: '单挂衣',
        labelEh: 'HG-1(ONE BAR)'
      }, {
        value: '5',
        labelZh: '双挂衣',
        labelEh: 'HG-1(TWO BARS)'
      }, {
        value: '6',
        labelZh: 'OT-1超高1M内',
        labelEh: 'OT-1(OH WITHIN 1M)'
      }, {
        value: '7',
        labelZh: 'OT-2超高1M外2M内',
        labelEh: 'OT-1(OH 1M TO 2M)'
      }, {
        value: '8',
        labelZh: 'FR-1超宽或超高1M内',
        labelEh: 'FR-1(OH OR OW WITHIN 1M)'
      }, {
        value: '9',
        labelZh: 'FR-2超宽或超高1M内',
        labelEh: 'FR-1(OH AND OW WITHIN 1M)'
      }, {
        value: '10',
        labelZh: 'FR-3超限1M以上',
        labelEh: 'FR-(3OH OR OW MORE THAN 1M)'
      }, {
        value: '11',
        labelZh: '空箱',
        labelEh: 'EMPTY'
      }, {
        value: '12',
        labelZh: '半开门',
        labelEh: 'DOOR OPEN'
      }, {
        value: '13',
        labelZh: '废品',
        labelEh: 'SCRAPS'
      }, {
        value: '14',
        labelZh: 'FR(OW)超高',
        labelEh: 'FR(OW)'
      }, {
        value: '15',
        labelZh: 'FR(FV)超高和超宽',
        labelEh: 'FR(RV)'
      }, {
        value: '16',
        labelZh: 'OT(OH)超高',
        labelEh: 'OT(OH)'
      }, {
        value: '17',
        labelZh: 'FR(OH)超高',
        labelEh: 'FR(OH)'
      }, {
        value: '18',
        labelZh: '废纸',
        labelEh: 'WASTE PARER'
      }, {
        value: '19',
        labelZh: '空箱半危',
        labelEh: 'ENPTY%DG'
      }, {
        value: '20',
        labelZh: 'FR-4[FR超长]',
        labelEh: 'FR-4(OL)'
      }, {
        value: '21',
        labelZh: 'FR-5[FR超长和超宽]',
        labelEh: 'FR-5(OL AND OW)'
      }, {
        value: '22',
        labelZh: 'FR-6[FR超长和超宽超高]',
        labelEh: 'RF-6(OL AND OW AND OH)'
      }, {
        value: '23',
        labelZh: 'FR-7[FR超长和超高]',
        labelEh: 'FR-7(OL AND OH)'
      }],
      pickupYardList: [{
        value: '0',
        labelEh: 'Yard1'
      }, {
        value: '1',
        labelEh: 'Yard2'
      }],
      isSplitList: [{
        value: '0',
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: '1',
        labelEh: 'YES',
        labelZh: '是'
      }],
      lineTypeList: [{
        value: 0,
        labelEh: 'Feeder',
        labelZh: '支线'
      }, {
        value: 1,
        labelEh: 'Ocean',
        labelZh: '干线'
      }],
      directionList: [{
        value: '0',
        labelEh: 'One Way',
        labelZh: '单程'
      }, {
        value: '1',
        labelEh: 'Two Way',
        labelZh: '双程'
      }],
      fullEmptyTypeList: [{
        value: '0',
        labelEh: 'Full',
        labelZh: '重去重回'
      }, {
        value: '1',
        labelEh: 'Empty',
        labelZh: '重去重回'
      }, {
        value: '2',
        labelEh: 'Empty',
        labelZh: '空去回重'
      }, {
        value: '3',
        labelEh: 'Empty',
        labelZh: '空去回空'
      }],
      containerSizeList: [{
        value: '0',
        labelEh: 'Standard container size',
        labelZh: '标准集装箱尺寸'
      }, {
        value: '1',
        labelEh: 'Non-standard container size',
        labelZh: '非标准集装箱尺寸'
      }],
      fullEmptyTypeListType: [{
        value: 1,
        labelEh: 'Horizontal bar',
        labelZh: '单杠'
      }, {
        value: 2,
        labelEh: 'Parallel bars',
        labelZh: '双杠'
      }],
      navTabList: [{
        name: '基础信息',
        nameEn: 'Basic information'
      }, {
        name: '收发通信息',
        nameEn: 'Shipper/Consignee '
      }, {
        name: '货物信息',
        nameEn: 'Cargo information'
      }, {
        name: '下货纸箱信息',
        nameEn: 'Unloading carton information'
      }, {
        name: '其他信息',
        nameEn: 'Other information '
      }],
      selectedIndex: 0,
      rules: {
        bkNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        hsCodeCn: [{
          required: false,
          max: 8,
          trigger: 'change'
        }],
        hsCodeJp: [{
          required: false,
          max: 6,
          trigger: 'change'
        }],
        hsCode: [{
          required: false,
          max: 20,
          trigger: 'change'
        }],
        bookingFwdEmail: [{
          required: false,
          message: this.$t('home.messageSix'),
          trigger: 'blur'
        }, {
          required: false,
          type: 'email',
          message: this.$t('home.messageThree'),
          trigger: ['blur', 'change']
        }]
        // contactNumber: [
        //   { required: false, trigger: 'blur' },
        //   {
        //     required: false,
        //     pattern: /^1[3-9]\d{9}$/,
        //     // message: '电话号码格式不正确',
        //     trigger: ['blur', 'change']
        //   }
        // ]
      }
    };
  },
  watch: {
    isToastSave: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          if (this.handleBeforeRouteLeave()) {
            this.handleCloseDetail();
          } else {
            this.ishandleDelTag();
          }
        }
      },
      immediate: true
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo', 'isToastSave', 'isToastSavePath'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['DOC_SOCRETURN', 'SOC_CONTAINER_SIZE', 'MKT_SOC_FULL_EMPTY', 'DOC_DG_DIVISION_PACKAGING_GROUP', 'BOOKINGTYPE', 'CDM_SERVICE_MODE', 'PAID_TYPE', 'DOC_CONTACT_TYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      console.log(res, 'res');
      _this.bookingTypeList = res.BOOKINGTYPE;
      _this.vesselTypeList = res.CDM_SERVICE_MODE;
      _this.paidTypeList = res.PAID_TYPE;
      _this.packageDescList = res.DOC_DG_DIVISION_PACKAGING_GROUP;
      _this.containerSizeList = res.SOC_CONTAINER_SIZE;
      _this.fullEmptyTypeList = res.MKT_SOC_FULL_EMPTY;
      _this.directionList = res.DOC_SOCRETURN;
      _this.contactTypeCodeList = res.DOC_CONTACT_TYPE ? res.DOC_CONTACT_TYPE : [];
      // soc
    });
  },
  mounted: function mounted() {
    this.queryListPackageType();
    this.form.templateBookingHeadComId = this.$route.query.templateBookingHeadComId || null;
    this.templateType = this.$route.query.templateType;
    console.log('9999', this.form.templateBookingHeadComId);
    if (this.form.templateBookingHeadComId) {
      this.hanldeGetDetail();
    } else {
      this.handleSetMessage();
    }
  },
  activated: function activated() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.action !== 'cancel' && this.handleBeforeRouteLeave()) {
      this.handleCloseDetail();
    } else {
      next();
    }
  },
  methods: {
    // 打开提示框
    openDialog: function openDialog(item, index, biteLength) {
      this.dialogContent = item;
      this.currentDialogIndex = index;
      this.$refs.myDialog.openDialog(biteLength);
    },
    // 提交
    confirm: function confirm(inpText) {
      if (this.currentDialogIndex === 1) {
        this.form.cargoDesc = inpText;
      } else if (this.currentDialogIndex === 2) {
        this.form.cargoShippingMark = inpText;
      }
    },
    generateAndSortArray: function generateAndSortArray(webBkCusCatalogComs, sequence) {
      var result = [];
      sequence.forEach(function (seq) {
        var found = webBkCusCatalogComs.find(function (item) {
          return item.sequence === seq;
        });
        if (found) {
          result.push(found);
        } else {
          var newObj = {
            catalogContent: '',
            bkCusCatalogWebComId: null,
            bkCustomerWebComId: null,
            sequence: seq,
            printOrder: seq
          }; // Default values assumed based on the example
          result.push(newObj);
        }
      });
      return result;
    },
    // 处理收法通的信息
    handleSetMessage: function handleSetMessage() {
      var _this2 = this;
      this.form.webBkCustomerComs = this.handleInfoShou(this.form.webBkCustomerComs);
      var sequence = ['1', '2', '7', '8', '10', '9', '15', '16', '3', '5', '6', '99', '11', '12', '13', '14'];
      this.form.webBkCustomerComs.forEach(function (item) {
        item.webBkCusCatalogComs = _this2.generateAndSortArray(item.webBkCusCatalogComs, sequence);
      });
    },
    // 处理收法通信息
    handleInfoShou: function handleInfoShou(data) {
      // 数组 a
      var a = [0, 1, 2, 3];
      // 遍历数组 a
      a.forEach(function (type) {
        // 查找是否存在对应的 customerType
        var exists = data.some(function (item) {
          return item.customerType === type;
        });
        // 如果不存在，添加新的对象
        if (!exists) {
          data.push({
            companyName: null,
            customerName: null,
            customerCode: null,
            customerType: type,
            webBkCusCatalogComs: []
          });
        }
      });
      // 按 customerType 排序
      return data.sort(function (a, b) {
        return a.customerType - b.customerType;
      });
    },
    hanldeGetDetail: function hanldeGetDetail() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.getMyTemplate)(this.form.templateBookingHeadComId).then(function (res) {
        res.data.webBkImoComs = res.data.webBkCargoComs.length && res.data.webBkCargoComs[0].webBkImoComs || [];
        res.data.webBkReeferComs = res.data.webBkCargoComs.length && res.data.webBkCargoComs[0].webBkReeferComs || [];
        _this3.form = res.data;
        _this3.form.porName = _this3.form.webBkExtendComs.length && _this3.form.webBkExtendComs[0].porName || '';
        _this3.form.delName = _this3.form.webBkExtendComs.length && _this3.form.webBkExtendComs[0].delName || '';
        _this3.handleSetDelteList();
        _this3.handleSetMessage();
        setTimeout(function () {
          _this3.oldData = JSON.parse(JSON.stringify(_this3.form)); //用来对于是否被更改
          _this3.newData = _this3.form; //用来对于是否被更改
          if (_this3.clickButton) {
            _this3.ishandleDelTag();
            _this3.clickButton = false;
          }
        }, 100);
        console.log(_this3.form, 'form');
      }).finally(function () {
        _this3.loading.close();
      });
    },
    handleBeforeRouteLeave: function handleBeforeRouteLeave() {
      var data = {
        newData: this.newData || this.form,
        oldData: this.oldData
      };
      var newFormString = JSON.stringify(data.newData);
      var oldFormString = JSON.stringify(data.oldData);
      if (oldFormString !== newFormString) {
        return true;
      } else {
        return false;
      }
    },
    handleCloseLast: function handleCloseLast() {
      if (this.handleBeforeRouteLeave()) {
        this.handleCloseDetail();
      } else {
        this.ishandleDelTag();
      }
    },
    handleCloseDetail: function handleCloseDetail() {
      var _this4 = this;
      this.$confirm(this.$t('home.closeWaring'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('home.buttonAdd'),
        cancelButtonText: this.$t('home.closeWaringTwo'),
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(function () {
        _this4.handleSave();
        _this4.clickButton = true;
      }).catch(function (action) {
        _this4.action = action;
        if (action === 'close') {} else {
          _this4.ishandleDelTag();
        }
      });
    },
    ishandleDelTag: function ishandleDelTag() {
      var data = {
        view: this.isToastSavePath || this.$route
      };
      this.$store.dispatch('tagsView/detailTabDelete', data);
      this.$store.dispatch("isSaveTip/isToastSave", false);
    },
    delTag: function delTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
      });
    },
    // 冷箱和危险品特殊处理
    handleSetFormat: function handleSetFormat() {
      var webBkCargoComs = {};
      if (this.form.webBkImoComs.length > 0) {
        webBkCargoComs.webBkImoComs = this.form.webBkImoComs;
      }
      if (this.form.webBkReeferComs.length > 0) {
        webBkCargoComs.webBkReeferComs = this.form.webBkReeferComs;
      }
      // 如果webBkCargoComs不是空对象才push
      if (JSON.stringify(webBkCargoComs) !== '{}') {
        this.form.webBkCargoComs.push(webBkCargoComs);
      }
    },
    // 保存
    handleSave: function handleSave() {
      var _this5 = this;
      //  const form = JSON.parse(JSON.stringify(this.form))
      //  let newForm = form
      //  newForm = this.handSetData(form)
      console.log(this.form.webBkCargoComs, 'form222');
      //  if(this.form.templateBookingHeadComId){
      //    newForm = this.handSetData(form)
      //  }

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this5.form.deliveryDocumentMethod = 1;
          // 冷箱和危险品特殊处理
          if (_this5.form.templateBookingHeadComId) {
            _this5.handSetData(_this5.form);
            if (_this5.form.webBkCargoComs.length < 1) {
              _this5.handleSetFormat();
            } else {
              _this5.form.webBkCargoComs[0].webBkImoComs = _this5.form.webBkImoComs;
              _this5.form.webBkCargoComs[0].webBkReeferComs = _this5.form.webBkReeferComs;
            }
          } else {
            _this5.form.webBkExtendComs = [{
              porName: _this5.form.porName,
              delName: _this5.form.delName
            }];
            _this5.handleSetFormat();
          }
          _this5.loading = (0, _utils.load)();
          (0, _booking.myTemplateSave)(_this5.form).then(function (res) {
            console.log(res);
            _this5.$store.dispatch("isSaveTip/isToastSave", false);
            if (res.success) {
              _this5.$message({
                message: _this5.$t('home.saveSuccess'),
                type: 'success'
              });
              _this5.form.templateBookingHeadComId = res.data.templateBookingHeadComId;
              _this5.hanldeGetDetail();
              _this5.$router.push({
                path: '/bookingSpace/myBookingTemplateDetail',
                query: {
                  templateBookingHeadComId: _this5.form.templateBookingHeadComId,
                  templateType: 'edit'
                }
              });
            }
          }).catch(function (err) {
            _this5.clickButton = false;
            _this5.$message({
              message: _this5.$t('home.failMessage'),
              type: 'warning'
            });
          }).finally(function () {
            _this5.loading.close();
          });
        } else {
          _this5.$nextTick(function () {
            var errorField = document.querySelector(".is-error");
            if (errorField) {
              // 滚动到第一个校验错误的元素
              errorField.scrollIntoView({
                behavior: "smooth",
                block: "center"
              });
            }
          });
        }
      });
    },
    handleSetDelteList: function handleSetDelteList() {
      this.form.deleteWebBkPreContainerComs = []; // 下货箱信息
      this.form.deleteWebBkRoutingComs = []; // 中转
      this.form.deleteWebBkImoComs = []; // imo
      this.form.deleteWebBkReeferComs = []; // 冷箱
      this.form.deleteWebBkAkComs = []; // 特种箱
      this.form.deleteWebBkSocComs = []; // soc
      this.form.deleteWebBkHgComs = []; // 特种箱
    },
    //  处理被删除的数据
    handSetData: function handSetData(form) {
      // 下货纸箱
      form.webBkPreContainerComs = [].concat((0, _toConsumableArray2.default)(form.webBkPreContainerComs), (0, _toConsumableArray2.default)(form.deleteWebBkPreContainerComs));
      console.log(form.webBkPreContainerComs, form.deleteWebBkPreContainerComs, 'form.webBkPreContainerComs');
      delete form.deleteWebBkPreContainerComs;
      // 中转
      form.webBkRoutingComs = [].concat((0, _toConsumableArray2.default)(form.webBkRoutingComs), (0, _toConsumableArray2.default)(form.deleteWebBkRoutingComs));
      delete form.deleteWebBkRoutingComs;
      // 危险品
      form.webBkImoComs = [].concat((0, _toConsumableArray2.default)(form.webBkImoComs), (0, _toConsumableArray2.default)(form.deleteWebBkImoComs));
      console.log(form.webBkImoComs, form.deleteWebBkImoComs, 'form.000webBkImoComs');
      delete form.deleteWebBkImoComs;
      // 冷箱
      form.webBkReeferComs = [].concat((0, _toConsumableArray2.default)(form.webBkReeferComs), (0, _toConsumableArray2.default)(form.deleteWebBkReeferComs));
      delete form.deleteWebBkReeferComs;
      // 特种箱
      form.webBkAkComs = [].concat((0, _toConsumableArray2.default)(form.webBkAkComs), (0, _toConsumableArray2.default)(form.deleteWebBkAkComs));
      delete form.deleteWebBkAkComs;
      // soc
      form.webBkSocComs = [].concat((0, _toConsumableArray2.default)(form.webBkSocComs), (0, _toConsumableArray2.default)(form.deleteWebBkSocComs));
      delete form.deleteWebBkSocComs;
      // 挂衣箱
      form.webBkHgComs = [].concat((0, _toConsumableArray2.default)(form.webBkHgComs), (0, _toConsumableArray2.default)(form.deleteWebBkHgComs));
      delete form.deleteWebBkHgComs;
      return form;
    },
    // 获取包装类型
    queryListPackageType: function queryListPackageType() {
      var _this6 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListPackageType)(data).then(function (res) {
        _this6.packageTypeList = res.data.records || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "SERVICE_MODE"
      })).then(function (res) {
        _this6.transportationTermsList = res.data || [];
      });
      (0, _booking.queryListCodeName)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "CARGO_TYPE"
      })).then(function (res) {
        _this6.cargoList = res.data || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this6.containerTypeList = res.data || [];
      });
    },
    selectTab: function selectTab(index) {
      this.selectedIndex = index;
      this.scrollToTarget(index);
    },
    scrollToTarget: function scrollToTarget(index) {
      var datamap = {
        0: 'basicInfo',
        1: 'consignerInfo',
        2: 'cargoInfo',
        3: 'boxInfo',
        4: 'otherInfo'
      };
      var offsetTop = document.getElementById(datamap[index]).offsetTop;
      this.$refs.scrollMain.scrollTop = offsetTop - 50;
    }
  }
};